export default __webpack_public_path__ + "static/media/autosuggestion-loader.a0502fbf.gif";